import { useEffect, useRef, useState } from 'react';

export function useMinimumLoading(isLoading: boolean, minMs = 2000): boolean {
  const [show, setShow] = useState(isLoading);
  const startRef = useRef<number | null>(null);

  useEffect(() => {
    if (isLoading) {
      startRef.current = Date.now();
      setShow(true);
      return;
    }

    const elapsed = Date.now() - (startRef.current ?? Date.now());
    const remaining = Math.max(0, minMs - elapsed);

    const t = setTimeout(() => setShow(false), remaining);
    return () => clearTimeout(t);
  }, [isLoading, minMs]);

  return show;
}